import React from 'react'
import TopNavBar from '../usercomponents/TopNavBar'
import Footer from '../usercomponents/Footer'
import SideBar from '../usercomponents/SideBar'

function Dashboard() {
  const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
  const studentName = sessionData ? `${sessionData.firstName} ${sessionData.lastName}` : 'Student';
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="row gy-4">
            <div className="col-xxl-12">
              <div className="card h-100">
                <div className="card-body grettings-box-two position-relative z-1 p-0">
                  <div className="row align-items-center h-100">
                    <div className="col-lg-6">
                      <div className="grettings-box-two__content">
                        <h2 className="fw-medium mb-0 flex-align gap-10">
                          Hi, {studentName}{" "}
                          <img src="/assets/images/icons/wave-hand.png" alt="" />{" "}
                        </h2>
                        <h2 className="fw-medium mb-16">
                          Welcome to IFM Edu Academy!
                        </h2>
                        <p className="text-15 text-gray-400">
                          Congratulations on your right decision.
                        </p>
                        <a
                          href="/courses"
                          className="btn btn-main rounded-pill mt-32"
                        >
                          Explore Courses
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-6 d-md-block d-none mt-auto">
                      <img src="/assets/images/thumbs/gretting-thumb2.png" alt="" />
                    </div>
                  </div>
                  <img
                    src="/assets/images/bg/star-shape.png"
                    className="position-absolute start-0 top-0 w-100 h-100 z-n1 object-fit-contain"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Dashboard